import _axios from "../../../httpService";
import { prefixUrl } from "../../../utils/utilsData";
import { toast } from "react-toastify";
import numeric from "../../../utils/NumericFunction";

export const getInsuranceTypeData = async (setInsuranceType, setIsLoad) => {
  const response = await _axios.get(prefixUrl() + `/insurance/?request=insuranceType`)
  if (response.data.status) {
    setInsuranceType(response.data.data)
    setIsLoad(true)
  } else {
    toast.error(response.data.message)
  }
}

export const getOrganizationList = async (setOrganizationList) => {
  const response = await _axios.get(prefixUrl() + `/insurance/?request=organizationList`)
  if (response.data.status) {
    setOrganizationList(response.data.data)
  } else {
    toast.error(response.data.message)
  }
}

export const getInsuranceData = async (setInsuranceData, sendData, setSendData, setHasPlate) => {
  const response = await _axios.get(prefixUrl() + `/insurance/?request=insuranceTypeData&insuranceTypeId=` + sendData?.typeId);
  if (response.data.status) {
    setInsuranceData(response.data.data);
    setHasPlate(response.data.hasPlate);
    // اگر سال شماره بیمه نامه تغییر نکرده بود ، مقدار پیش فرض رو ذخیره کن
    if (!sendData.insuranceNumberYear) {
      setSendData((prevData) => ({
        ...prevData,
        insuranceNumberYear: response.data.data[0],
      }));
    }
  } else {
    toast.error(response.data.message);
  }
};

export const AddLegalPerson = async (sendData, setSendData, setInsuranceStep) => {

  if (sendData?.nationalId === "") {
    return toast.error("شناسه ملی را وارد کنید")
  }
  if (sendData?.organizationName === "") {
    return toast.error("عنوان سازمان را وارد کنید")
  }

  const Data = {
    request: "personSubmit",
    personType: "legal",
    formData: {
      nationalId: sendData?.nationalId,
      organizationName: sendData?.organizationName,
      mobileNumber: sendData?.mobileNumber,
      telephone: sendData?.telephone,
      economicCode: sendData?.economicCode,
      personName: sendData?.personName,
      address: sendData?.address,
      postalCode: sendData?.postalCode,
    }
  }
  const response = await _axios.post(prefixUrl() + "/insurance/", Data);
  if (response.data.status) {
    toast.success(response.data?.message)
    setSendData({ ...sendData, personId: response.data?.id })
    setInsuranceStep(3)
  } else {
    toast.error(response.data?.message)
  }
}

export const AddRealPerson = async (sendData, setSendData, setInsuranceStep) => {

  if (sendData?.nationalId === "") {
    return toast.error("کد ملی را وارد کنید")
  }
  if (sendData?.fullName === "") {
    return toast.error("نام و نام خانوادگی را وارد کنید")
  }
  if (sendData?.mobileNumber === "") {
    return toast.error("شماره موبایل را وارد کنید")
  }

  const Data = {
    request: "personSubmit",
    personType: "real",
    formData: {
      nationalId: sendData?.nationalId,
      fullName: sendData?.fullName,
      mobileNumber: sendData?.mobileNumber,
      telephone: sendData?.telephone,
      address: sendData?.address,
      postalCode: sendData?.postalCode,
    }
  }
  const response = await _axios.post(prefixUrl() + "/insurance/", Data);
  if (response.data.status) {
    toast.success(response.data?.message)
    setSendData({ ...sendData, personId: response.data?.id })
    setInsuranceStep(3)
  } else {
    toast.error(response.data?.message)
  }
}

export const AddRealOrganizePerson = async (sendData, setSendData, setInsuranceStep) => {

  if (sendData?.nationalId === "") {
    return toast.error("کد ملی را وارد کنید")
  }
  if (sendData?.fullName === "") {
    return toast.error("نام و نام خانوادگی را وارد کنید")
  }
  if (sendData?.mobileNumber === "") {
    return toast.error("شماره موبایل را وارد کنید")
  }
  if (sendData?.organizationId === "") {
    return toast.error("سازمان را انتخاب کنید")
  }

  const Data = {
    request: "personSubmit",
    personType: "real-organize",
    formData: {
      nationalId: sendData?.nationalId,
      fullName: sendData?.fullName,
      mobileNumber: sendData?.mobileNumber,
      telephone: sendData?.telephone,
      address: sendData?.address,
      postalCode: sendData?.postalCode,
      organizationId: sendData?.organizationId,
      personnelNumber: sendData?.personnelNumber,
    }
  }
  const response = await _axios.post(prefixUrl() + "/insurance/", Data);
  if (response.data.status) {
    toast.success(response.data?.message)
    setSendData({ ...sendData, personId: response.data?.id })
    setInsuranceStep(3)
  } else {
    toast.error(response.data?.message)
  }
}

export const insuranceLastNumber = (sendData, setInsuranceStep) => {
  const todayDate = new Date().toLocaleDateString('fa-IR', { year: 'numeric' });
  const currentYearNumber = numeric.p2e(todayDate);

  if (!sendData.insuranceNumberYear || sendData.insuranceNumberYear.length < 4) {
    toast.error("سال بیمه نامه نباید خالی یا غیر معتبر باشد.");
    return false;
  }

  if (+sendData.insuranceNumberYear > currentYearNumber) {
    toast.error("سال بیمه نامه نمی‌تواند از سال جاری بیشتر باشد.");
    return false;
  }

  if (sendData?.insuranceLastNumber === "") {
    return toast.error("شماره بیمه نامه را وارد کنید")
  }

  setInsuranceStep(4)
}

export const CheckInsurancePrice = (sendData, setInsuranceStep) => {
  if (sendData?.payType === "اقساط" && sendData?.insurancePrice === "0") {
    return toast.error("برای ادامه مراحل دکمه اعمال را بزنید");
  }

  if (sendData?.payType === "نقدی" && sendData?.insurancePrice === "0") {
    return toast.error("مبلغ کل حق بیمه نمی تواند صفر باشد");
  }

  if (sendData?.payType === "نقدی") {
    setInsuranceStep(6);
  } else {
    setInsuranceStep(5);
  }
};



export const CustomerInsurancePrice = (sendData, setInsuranceStep) => {
  if (sendData?.customerInstallmentDetails.length === 0) {
    return toast.error("برای ادامه مراحل دکمه اعمال را بزنید")
  }

  if (+sendData?.customerInstallmentDetailsTotal !== (+sendData?.customerPay)) {
    return toast.error("مبلغ جمع اقساط درست نمی باشد")
  }

  setInsuranceStep(6)
}

export const BankAndAgentList = async (setBankAndAgentList, setIsLoad, setSendData) => {

  const response = await _axios.get(prefixUrl() + "/insurance/?request=bankAndAgentList");
  if (response.data.status) {
    const { bank, fund } = response.data.data;

    const defaultBank = bank.find(item => item.default === "1");
    const defaultFund = fund.find(item => item.default === "1");

    setSendData(prev => ({
      ...prev,
      bankId: defaultBank ? defaultBank.value : "",
      customerBankId: defaultBank ? defaultBank.value : "",
      customerFundId: defaultFund ? defaultFund.value : ""
    }));

    setBankAndAgentList(response.data.data)
    setIsLoad(true)
  } else {
    toast.error(response.data.message)
  }
}

export const GoLastPage = (sendData, setInsuranceStep, paymentType) => {
  if (sendData.receiveType === "personal-agent") {
    if (paymentType === "bank" && !sendData.customerBankId) {
      toast.error("لطفا بانک را انتخاب کنید.");
      return;
    }
    if (paymentType === "cash" && !sendData.customerFundId) {
      toast.error("لطفا صندوق را انتخاب کنید.");
      return;
    }
    if (paymentType === "both" && (!sendData.customerBankId || !sendData.customerFundId)) {
      toast.error("لطفا بانک و صندوق را انتخاب کنید.");
      return;
    }
  }
  if (!sendData.bankId) {
    toast.error("لطفا بانک نماینده را انتخاب کنید.");
    return;
  }
  if (sendData.hasAgent && !sendData.agentId) {
    toast.error("لطفا بازاریاب را انتخاب کنید.");
    return;
  }
  setInsuranceStep(7)
}

export const SubmitInsurance = async (sendData, setSendData, setInsuranceStep, GoToInsurancePrint) => {
  const Data = { request: "insuranceSubmit", data: sendData }
  if (sendData.payType === "نقدی") {
    sendData.customerReceivedExtra = "0";
  }
  const response = await _axios.post(prefixUrl() + "/insurance/", Data);
  if (response.data.status) {
    toast.success(response.data.message)
    setSendData({
      typeId: "",
      personType: "real",
      nationalId: "",
      personId: "",
      organizationName: "",
      mobileNumber: "",
      telephone: "",
      economicCode: "",
      personName: "",
      address: "",
      fullName: "",
      postalCode: "",
      organizationId: "",
      personnelNumber: "",
      insuranceLastNumber: "",
      insuranceNumberYear:"",
      plate: "",
      insurancePrice: "0",
      firstInternalDate: "",
      prePayment: "0",
      countInsurance: "1",
      eachInternalPrice: "0",
      customerInsurancePrice: "",
      customerOfferPrice: "0",
      customerPrePayment: "",
      customerFirstInternalDate: "",
      customerCountInsurance: 1,
      customerPay: "",
      hasAgent: false,
      agentId: "",
      receiveType: "default",
      bankId: "",
      partOne: "",
      partTwo: "",
      partThree: "الف",
      partFour: "",
      partFive: "",
      partSix: "",
      partSeven: "",
      partEight: "",
      installmentDetails: [],
      customerInstallmentDetails: [],
      customerInstallmentDetailsTotal: 0,
      customerPrePaymentPayType: "cash",
      payType: "اقساط",
      customerBankId: "",
      customerFundId: "",
      insuranceNumber: "",
    })
    setInsuranceStep(1);
    if (sendData.payType === "اقساط") {
      GoToInsurancePrint(response?.data?.data.insuranceId);
    }
  } else {
    toast.error(response.data.message)
  }
}